// removed by extract-text-webpack-plugin
module.exports = {"Menu":"style__Menu___2x5zB","Additional":"style__Additional___39WQU","Title":"style__Title___1DygX","Checkboxes":"style__Checkboxes___2mbZM","Checkbox":"style__Checkbox___2FCzd","Button":"style__Button___lV3T3","FirstColumn":"style__FirstColumn___38yW-","SecondColumn":"style__SecondColumn___2V3id","ButtonWrap":"style__ButtonWrap___133K7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/Decoration/style.scss
// module id = 1342
// module chunks = 0